export const fullName = (givenName: string, familyName: string): string | undefined => {
  if (!givenName && !familyName) return undefined;
  if (givenName && familyName) return `${givenName} ${familyName}`;
  if (givenName) return givenName;
  return familyName;
};
